import React from 'react';
import PropTypes from 'prop-types';

export default function ReportIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <g fill={fill} data-name='Grupo 152735'>
        <path
          d='M2 1v12.3h5.766v5.766h9.251V1Zm3.084 3.084h5.766v1.141H5.084Zm0 3.084h5.766v1.141H5.084Zm0 4.225v-1.141h5.766v1.141Zm8.85 4.625H9.709v-1.141h4.225Zm0-4.625h-1.141v-1.141h1.172v1.141Zm0-3.084h-1.141V7.168h1.172v1.141Zm0-3.053h-1.141V4.115h1.172v1.141Z'
          data-name='Caminho 22036'
        />
        <path d='M6.627 18.761v-4.286H2.341Z' data-name='Caminho 22037' />
      </g>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148050' />
    </svg>
  );
}

ReportIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

ReportIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
